export enum WorkflowEditorNotificationType {
    Error = 'alert-danger',
    Info = 'alert-info',
    Warning = 'alert-warning',
    Success = 'alert-success',
}
